import { useEffect } from 'react';
import type { MutableRefObject, RefObject } from 'react';

export const useIntersectionObserver = ({
  onIntersectionChange,
  threshold,
  elementRef,
  enabled = true,
}: {
  onIntersectionChange: (entry: IntersectionObserverEntry) => void;
  threshold: IntersectionObserverInit['threshold'];
  elementRef: MutableRefObject<HTMLElement> | RefObject<HTMLElement>;
  enabled?: boolean;
}) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const element = elementRef.current;

    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        onIntersectionChange(entry);
      },
      { threshold }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [enabled, onIntersectionChange, threshold, elementRef]);
};
